<template>
    <div :class="{ web: isPc, mobile: !isPc }">
        <viemao-header :isPc="isPc"></viemao-header>
        <section class="tool-header-area">
            <h1 class="tool-title">{{ t("viemao_downloader_banner_h1") }}</h1>
            <div class="tool-header-text">
                {{ t("viemao_downloader_bannner_para1") }}
            </div>
            <div v-if="isPc" :class="{ 'download-tool-input': true }">
                <iconpark-icon name="link" class="linkIcon"></iconpark-icon>

                <input
                    type="text"
                    class="text-input"
                    v-model="downloadUrl"
                    :placeholder="placeholder"
                    @focus="onLinkFocus"
                    @blur="onLinkBlur"
                    @paste="pasteToGetVideoInfo"
                    @input="downloadUrlInput"
                />
                <button
                    :class="{ 'link-button': true, converterButton: false }"
                    :disabled="isDisable"
                    @click="getVideoInfo(3)"
                >
                    <template v-if="!showLoading">
                        <span>{{ t("viemao_downloader_bannner_button1") }}</span>
                    </template>
                    <iconpark-icon
                        v-if="showLoading"
                        class="loading-animation base-button-loading-icon"
                        style="font-size: 24px"
                        name="loading"
                    ></iconpark-icon>
                </button>
            </div>
            <div class="download-tool-input" v-else>
                <div class="input">
                    <iconpark-icon name="link" class="linkIcon"></iconpark-icon>
                    <input
                        type="text"
                        class="text-input"
                        v-model="downloadUrl"
                        :placeholder="placeholder"
                        @focus="onLinkFocus"
                        @blur="onLinkBlur"
                        @paste="pasteToGetVideoInfo"
                        @input="downloadUrlInput"
                    />
                </div>
                <button :class="{ 'link-button': true, converterButton: false }" @click="getVideoInfo(3)">
                    <template v-if="!showLoading">
                        <span>{{ t("viemao_downloader_bannner_button1") }}</span>
                    </template>
                    <iconpark-icon
                        v-if="showLoading"
                        class="loading-animation base-button-loading-icon"
                        style="font-size: 24px"
                        name="loading"
                    ></iconpark-icon>
                </button>
            </div>
            <p class="tool-user-guide-tip">
                <span> {{ t("viemao_downloader_bannner_para3") }} </span>
                {{ " " }}
                <router-link class="guide-tip-router" to="/usage-guidelines">{{
                    t("viemao_downloader_bannner_para4")
                }}</router-link>
            </p>
            <div v-show="isShowDownloaderHeaderMore">
                <div class="tool-video-detail" v-if="!showLoading">
                    <div class="video-image-info">
                        <img class="video-image" :src="previewVideoThumbnailUrl" alt="thumbnailImage" />
                        <div class="video-info-title">{{ previewVideoTitle }}</div>
                    </div>

                    <div class="video-download-info">
                        <!-- 有声音的视频 -->
                        <div v-if="lastWithAudioIndex !== -1" class="video-resource-item">
                            <div class="video-resource-title">Video with Audio</div>
                            <div
                                v-for="(option, index) in options.slice(0, lastWithAudioIndex + 1)"
                                :key="option.value"
                                class="video-resource-content"
                            >
                                <div class="video-des">
                                    <iconpark-icon class="video-icon" v-if="isPc" name="video-recorder"></iconpark-icon>
                                    <div class="video-config-info">
                                        Video + Audio ({{
                                            option.videoRatio.trim() + (option.fps == null ? "" : `、${option.fps}FPS`)
                                        }})
                                    </div>
                                    <div class="video-format">{{ option.ext }}</div>
                                </div>
                                <button
                                    :disabled="btnLoadings[index]"
                                    class="video-download-btn"
                                    @click="downloadVideo(index, 'Video with Audio')"
                                >
                                    <template v-if="btnLoadings[index]">
                                        <iconpark-icon
                                            class="loading-animation base-button-loading-icon"
                                            style="font-size: 24px"
                                            name="loading"
                                        ></iconpark-icon>
                                    </template>
                                    <template v-else>
                                        <iconpark-icon name="download" class="icon-download"></iconpark-icon
                                        >{{ t("viemao_downloader_bannner_button3") }}
                                    </template>
                                </button>
                            </div>
                        </div>
                        <!-- 没声音的视频 -->
                        <div class="video-resource-item">
                            <div class="video-resource-title">Video only</div>
                            <div
                                v-for="(option, index) in options.slice(lastWithAudioIndex + 1, firstPureAudioIndex)"
                                :key="option.value"
                                class="video-resource-content"
                            >
                                <div class="video-des">
                                    <template v-if="isPc">
                                        <iconpark-icon class="video-icon" name="video-recorder"></iconpark-icon>
                                        <iconpark-icon class="video-icon" name="volume-x"></iconpark-icon>
                                    </template>
                                    <div class="video-config-info">
                                        Video without Audio ({{
                                            option.videoRatio + (option.fps == null ? "" : `、${option.fps}FPS`)
                                        }})
                                    </div>
                                    <div class="video-format">{{ option.ext }}</div>
                                </div>
                                <button
                                    class="video-download-btn"
                                    :disabled="btnLoadings[lastWithAudioIndex + index + 1]"
                                    @click="downloadVideo(lastWithAudioIndex + index + 1, 'Video only')"
                                >
                                    <template v-if="btnLoadings[lastWithAudioIndex + index + 1]">
                                        <iconpark-icon
                                            class="loading-animation base-button-loading-icon"
                                            style="font-size: 24px"
                                            name="loading"
                                        ></iconpark-icon>
                                    </template>
                                    <template v-else>
                                        <iconpark-icon name="download" class="icon-download"></iconpark-icon
                                        >{{ t("viemao_downloader_bannner_button3") }}
                                    </template>
                                </button>
                            </div>
                        </div>
                        <!-- 音频 -->
                        <div v-if="firstPureAudioIndex !== -1" class="video-resource-item">
                            <div class="video-resource-title">Audio only</div>
                            <div
                                v-for="(option, index) in options.slice(firstPureAudioIndex, options.length)"
                                :key="option.value"
                                class="video-resource-content"
                            >
                                <div class="video-des">
                                    <iconpark-icon class="video-icon" v-if="isPc" name="volume-max"></iconpark-icon>
                                    <div class="video-config-info">
                                        Audio
                                        {{
                                            option.abr == null || option.abr == 0
                                                ? ""
                                                : "(" + Math.floor(option.abr) + "Kbps)"
                                        }}
                                    </div>
                                    <div class="video-format">{{ option.ext }}</div>
                                </div>
                                <button
                                    class="video-download-btn"
                                    :disabled="btnLoadings[firstPureAudioIndex + index]"
                                    @click="downloadVideo(firstPureAudioIndex + index, 'Audio only')"
                                >
                                    <template v-if="btnLoadings[firstPureAudioIndex + index]">
                                        <iconpark-icon
                                            class="loading-animation base-button-loading-icon"
                                            style="font-size: 24px"
                                            name="loading"
                                        ></iconpark-icon>
                                    </template>
                                    <template v-else>
                                        <iconpark-icon name="download" class="icon-download"></iconpark-icon
                                        >{{ t("viemao_downloader_bannner_button3") }}
                                    </template>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!showLoading" @click="reset" class="tool-reset-btn">
                    {{ t("viemao_downloader_bannner_button2") }}
                    <iconpark-icon name="Refresh"></iconpark-icon>
                </div>
            </div>
        </section>

        <section v-if="isPc" class="tool-download-link-wrapper">
            <div class="tool-download-link-top">
                <img src="../images/icon-videmao-download.webp" alt="downloadIcon" />
                <div class="download-link-text">
                    <div class="download-link-title">
                        {{ t("viemao_downloader_banner2_h2") }}
                    </div>
                    <div class="download-link-des">
                        {{ t("viemao_downloader_client_para1") }}
                    </div>
                </div>
                <button @click="clickDownloadApp('header')" class="download-link-btn">
                    <template v-if="!appDownloading">
                        <iconpark-icon name="download" class="icon-download"></iconpark-icon>
                        <span>{{ t("viemao_downloader_client_button") }}</span>
                    </template>
                    <iconpark-icon
                        v-if="appDownloading"
                        class="loading-animation base-button-loading-icon"
                        style="font-size: 24px"
                        name="loading"
                    ></iconpark-icon>
                </button>
            </div>
        </section>

        <section class="section-block">
            <div class="tool-function-block">
                <h2 class="fun-block-title">{{ functionBlock.subTitle }}</h2>
                <div class="fun-block-des">{{ functionBlock.titleDescribe }}</div>
                <div class="fun-block-content">
                    <div v-for="(item, index) in functionBlock.content" :key="index" class="tool-fun-item">
                        <div class="fun-item-icon">
                            <iconpark-icon :name="item.icon"></iconpark-icon>
                        </div>
                        <h3 class="fun-item-title">
                            {{ item.title }}
                        </h3>
                        <div class="fun-item-des">
                            {{ item.des }}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-block">
            <div class="tool-use-block">
                <h2 class="use-block-title">
                    {{ useMethodBlock.subTitle }}
                </h2>
                <div class="use-block-content">
                    <div v-for="(item, index) in useMethodBlock.content" :key="index" class="use-block-item">
                        <img :src="require(`@/images/${item.imageSuffix}`)" :alt="item.title" />
                        <h3 class="use-title">
                            {{ item.title }}
                        </h3>
                        <div class="use-des">{{ item.des }}</div>
                    </div>
                </div>
            </div>
        </section>

        <section v-if="isPc" class="section-block">
            <div class="domain-block">
                <h2>{{ domainBlock.subTitle }}</h2>
                <img src="../images/image-how-to-use-short-domain.webp" alt="use-short-domain" />
                <div class="domain-content">
                    <div v-for="(item, index) in domainBlock.content" :key="index" class="domain-item">
                        <div class="domain-title">
                            {{ item.title }}
                        </div>
                        <div class="domain-des">
                            {{ item.des }}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="tool-faq-block">
            <div class="faqHeader">
                <h2 class="faqTitle">{{ questionBlock.subTitle }}</h2>
                <p class="faqDescribe">{{ questionBlock.titleDescribe }}</p>
            </div>
            <div class="faqContent">
                <template v-for="(value, newIndex) in questionBlock.content" :key="newIndex">
                    <div class="faqContentTitle" @click="onIconClick(newIndex)">
                        <h3>{{ value.title }}</h3>
                        <iconpark-icon
                            name="add"
                            style="font-size: 24px; cursor: pointer"
                            v-if="showFaqContentInfo.indexOf(newIndex) === -1"
                            class="faqIcon"
                        >
                        </iconpark-icon>
                        <iconpark-icon name="less" style="font-size: 24px; cursor: pointer" v-else class="faqIcon">
                        </iconpark-icon>
                    </div>
                    <div class="faqContentInfo" ref="faqContentInfo" @click.stop="">
                        <template v-for="(text, i) in value.contentArr" :key="i">
                            <template v-if="text.type === 'text'">
                                <p v-for="(t, j) in text.value" :key="j">{{ t }}</p>
                            </template>
                            <ul v-else-if="text.type === 'ul'">
                                <li v-for="(t, j) in text.value" :key="j">{{ t }}</li>
                            </ul>
                        </template>
                    </div>
                </template>
            </div>
        </section>

        <section v-if="isPc" class="tool-download-link-bottom">
            <div class="tool-download-link-inner">
                <div class="download-left-content">
                    <h2 class="download-title">{{ t("viemao_downloader_client_h2") }}</h2>
                    <div class="download-des">{{ t("viemao_downloader_banner2_para1") }}</div>
                </div>
                <div class="download-right-content">
                    <img src="../images/image-viemao-download-bottom.webp" alt="viemaoDownloader" />
                    <button @click="clickDownloadApp('footer')" class="download-link-btn">
                        <template v-if="!appDownloading">
                            <iconpark-icon name="download" class="icon-download"></iconpark-icon>
                            <span>{{ t("viemao_downloader_client_button") }}</span>
                        </template>
                        <iconpark-icon
                            v-if="appDownloading"
                            class="loading-animation base-button-loading-icon"
                            style="font-size: 24px"
                            name="loading"
                        ></iconpark-icon>
                    </button>
                </div>
            </div>
        </section>

        <viemao-footer :isPc="isPc"></viemao-footer>

        <turnstileVisible
            v-if="showVisible"
            @verifyCallback="visibleVerify"
            @errorCallback="visibleError"
        ></turnstileVisible>
    </div>
</template>

<script setup>
// 拿到当前实例
import { ref, reactive, getCurrentInstance, onMounted } from "vue";
const { proxy } = getCurrentInstance();

import { useI18n } from "vue-i18n";

import * as constants from "@/constants";
import * as predicates from "@/utils/predicates";
import * as request from "@/http/httpRequest";
import send from "@/utils/sendStatistics";

import { invisible, getTempKey } from "@/utils/turnstileInvisible";
import { translateWrongCopyUploadByLink } from "@/utils/mapping";
import videoDownload from "@/utils/videoDownload";
// import { transferDownloadTypeCodeToString } from "@/utils/utils";
import { getRedirectedInfo, clearRedirectedInfo } from "@/helpers/redirectStorage";
import uesUpdateSize from "@/helpers/useUpdateSize";
import toolData from "@/utils/pageData/toolData";
import useLinkUploadError from "@/helpers/useLinkUploadError";

import turnstileVisible from "@/components/turnstileVisible.vue";
import viemaoHeader from "@/components/viemaoHeader.vue";
import viemaoFooter from "@/components/viemaoFooter.vue";

const { isPc } = uesUpdateSize();
const { t } = useI18n();

// 组件引用的方式，后续调整
const ElMessage = proxy.$message;
const { functionBlock, useMethodBlock, domainBlock, questionBlock } = toolData[0];

const { saveLinkErrorInfo, getLinkErrorInfo } = useLinkUploadError();

let faqContentInfo = ref();
let faqContentInfoHeight = [];
let showFaqContentInfo = reactive([]);
const showVisible = ref(false);
const downloadUrl = ref("");
const isCached = ref(0);
const targetVideoLink = ref(""); // 目标视频链接
const targetVideoSource = ref(-1); // 目标视频来源
const videoDownloadUrl = ref("");
// 定义下拉框的选项和当前选择的值
const options = ref([
    { label: "MP4", value: "1", url: "" },
    { label: "AVI", value: "2", url: "" },
]);

const btnLoadings = ref([false, false]);
const appDownloading = ref(false);
// 音频文件列表
// const audioOptions = ref([]);
// 当前选择的格式分辨率在options数组中的下标
const selectedOptionIndex = ref(0);
// options数组排序完成后，最后一个有声音的视频元素的下标
const lastWithAudioIndex = ref(-1);
// options数组排序完成后，第一个纯音频的元素的下标
const firstPureAudioIndex = ref(-1);
// downloader-header-more是否显示
const isShowDownloaderHeaderMore = ref(false);
// downloader-header-more视频封面
const previewVideoThumbnailUrl = ref("");
// downloader-header-more视频名称
const previewVideoTitle = ref("");
// downloader 的header按钮是否禁用
const isDisable = ref(false);

let videoLinkSource = ref(0);
let linkUploadErrorText = ref("Something went wrong, please try again");
let showLoading = ref(false);
let youtubeInfo = ref({});

const placeholder = t("viemao_downloader_bannner_para2");

/**
 * 计算分辨率的函数
 * @param width 视频的宽
 * @param height 视频的高
 */
const clickDownloadApp = (pos) => {
    let str = pos === "header" ? send.vmw_clickHeaderClient : send.vmw_clickFooterClient;
    send.collect(str);

    appDownloading.value = true;

    const ua = window.navigator.userAgent.toLowerCase();
    let downloadUrl = "";

    if (ua.includes("macintosh") || ua.includes("mac os x")) {
        downloadUrl = constants.MACOS_APP_URL;
    } else if (ua.includes("windows")) {
        downloadUrl = constants.WINDOWS_APP_URL;
    } else {
        ElMessage({
            message:
                "The current system does not support downloading this App for the time being. Please use Windows or macOS",
            type: "error",
        });
        appDownloading.value = false;
        return;
    }

    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = "";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setTimeout(() => {
        appDownloading.value = false;
    }, 1000);
};

const getResolutionLabel = (width, height) => {
    const smallerSide = Math.min(width, height);
    return smallerSide + "P";
};

function pasteToGetVideoInfo() {
    setTimeout(() => {
        if (downloadUrl.value.length > 0) {
            getVideoInfo(3);
        }
    }, 100);
}

function downloadUrlInput() {
    isDisable.value = false;
    if (!downloadUrl.value) {
        reset();
    }
}

function reset() {
    downloadUrl.value = "";
    isShowDownloaderHeaderMore.value = false;
}

// 手动验证成功
function visibleVerify(captchaToken) {
    showVisible.value = false;
    showLoading.value = true;
    isShowDownloaderHeaderMore.value = true;
    queryVideoInfo(targetVideoLink.value, targetVideoSource.value, constants.CLOUDFLARE_STATE_VISIBLE, captchaToken);
}
// 手动验证失败
function visibleError() {
    showVisible.value = false;
    showLoading.value = false;
    isShowDownloaderHeaderMore.value = false;
    send.collect(send.vmw_searchError);
    ElMessage({
        message: "Failed to pass verify, please try again",
        type: "error",
    });
}

const downloadVideo = (index, fileType) => {
    send.collect(send.vmw_downloadVideoFile, { fromButton: fileType });
    if (btnLoadings.value[index]) return;
    btnLoadings.value[index] = true;
    dealDownloadProcess(index, fileType);
};

const dealDownloadProcess = (index, fileType) => {
    youtubeInfo.value.selectedOptionIndex = index;
    youtubeInfo.value.downloadUrl = options.value[index].url;

    const sourceVideoUrl = youtubeInfo.value.sourceVideoUrl;
    const videoType = videoLinkSource.value;
    if (youtubeInfo.value.downloadUrl && youtubeInfo.value.downloadUrl.length > 0) {
        videoDownloadUrl.value =
            youtubeInfo.value.downloadUrl + "&title=" + encodeURIComponent(youtubeInfo.value.videoName);
    }
    downloadVideoWeb(undefined, undefined, videoDownloadUrl.value, sourceVideoUrl, videoType, index, fileType);
};

/**
 * web端的下载方法
 */
async function downloadVideoWeb(
    captchaType = constants.CLOUDFLARE_STATE_INVISIBLE,
    captchaToken,
    downloadUrl,
    sourceUrl,
    videoSource,
    index,
    fileType
) {
    const result = await videoDownload.downloadMediaByUrl(
        downloadUrl,
        "video",
        sourceUrl,
        Number(videoSource),
        2,
        index
    );
    // 过期或地址不存在
    if (result) {
        let temp = getTempKey();
        if (captchaType == constants.CLOUDFLARE_STATE_INVISIBLE) {
            // 人机验证
            const results = await invisible();
            let manualVerification = false;
            if (results.state === "success") {
                captchaToken = results.token;
            } else {
                manualVerification = results.manualVerification; //需要手动验证
            }
            // 打开手动验证
            if (manualVerification) {
                showVisible.value = true;
                return;
            }
        }
        const code = await videoDownload.downloadMediaByNewInfo(
            Object.assign({}, result, { captchaType, captchaToken, temp }),
            fileType
        );
        // 人机检测失败
        if (code == -6000) {
            ElMessage({
                message: "Failed to pass verify, please try again",
                type: "error",
            });
            send.collect(send.vmw_downloadVideoError, { fromButton: fileType });
        } else if (code == -6001) {
            // 需要主动人机检测
            showVisible.value = true;
        }
    }
    setTimeout(() => {
        btnLoadings.value[index] = false;
    }, 300);
}

function onIconClick(index) {
    if (showFaqContentInfo.indexOf(index) !== -1) {
        showFaqContentInfo.splice(showFaqContentInfo.indexOf(index), 1);
        faqContentInfo.value[index].style.height = 0;
    } else {
        showFaqContentInfo.push(index);
        faqContentInfo.value[index].style.height = faqContentInfoHeight[index] + "px";
    }
}
function getBlock4ContentInfoHeight() {
    for (let i = 0; i < faqContentInfo.value.length; i++) {
        faqContentInfoHeight.push(faqContentInfo.value[i].clientHeight);
    }
}

function setBlock4ContentInfoHeight() {
    for (let i = 0; i < faqContentInfo.value.length; i++) {
        faqContentInfo.value[i].style.height = 0;
    }
}
/**
 * 先判断链接类型，获取链接信息判断是否可用。跳转页面
 * @param videoType
 */
const getVideoInfo = (videoType) => {
    // 判断如果是cdyoutube域名进行的操作，直接跳转到viemao域名
    const currentHost = window.location.hostname;

    if (currentHost.includes("cdyoutube.com")) {
        window.location.href = "https://viemao.com/";
        return;
    }
    if (showLoading.value) return;
    send.collect(send.vmw_clickCTA);
    if (downloadUrl.value.trim() == "") {
        linkUploadErrorText.value = "Please enter a valid url";
        ElMessage({
            message: linkUploadErrorText.value,
            type: "error",
        });
        reset();
    } else {
        videoLinkSource.value = videoType;
        showLoading.value = true;
        // 目前只有youtube
        if (videoType == constants.VIDEO_LINK_SOURCE_YOUTUBE) {
            //youtube视频
            let isLinkValidable = predicates.isLinkYoutube(downloadUrl.value.trim());
            if (isLinkValidable) {
                isShowDownloaderHeaderMore.value = true;
                isDisable.value = true;
                queryVideoInfo(downloadUrl.value.trim(), 3);
            } else {
                showLoading.value = false;
                linkUploadErrorText.value = "Please enter a valid link";
                ElMessage({
                    message: linkUploadErrorText.value,
                    type: "error",
                });
                reset();
            }
        }
    }
};

/**
 * 判断当前将要请求的链接是否为3s内上传过且报错的链接，是则展示错误信息；不是则继续上传流程。
 * @param link 链接
 */
function judgeLinkCondition(link) {
    let callback = false;
    let lastErrorMessage = getLinkErrorInfo(link);
    if (lastErrorMessage !== undefined) {
        callback = true;
        // 若此链接存在错误信息
        setTimeout(() => {
            linkUploadErrorText.value = lastErrorMessage;
            showLoading.value = false;
            ElMessage({
                message: linkUploadErrorText.value,
                type: "error",
            });
        }, 500);
    }
    return callback;
}

/**
 * 获取视频信息
 */
async function queryVideoInfo(link, videoSource, captchaType = constants.CLOUDFLARE_STATE_INVISIBLE, captchaToken) {
    // 判断是否已缓存此链接
    if (judgeLinkCondition(link)) {
        isShowDownloaderHeaderMore.value = false;
        return;
    }
    let temp = getTempKey();
    if (captchaType == constants.CLOUDFLARE_STATE_INVISIBLE) {
        // 人机验证
        const results = await invisible();
        let manualVerification = false;
        if (results.state === "success") {
            captchaToken = results.token;
        } else {
            manualVerification = results.manualVerification; //需要手动验证
        }
        // 打开手动验证
        if (manualVerification) {
            targetVideoLink.value = link;
            targetVideoSource.value = videoSource;
            showVisible.value = true;
            showLoading.value = false;
            isShowDownloaderHeaderMore.value = false;
            return;
        }
    }
    // 若为youtube字幕下载，指定action为对应类型；否则默认为1-预取, 字幕下载器不支持预取, 后端默认不取字幕信息
    // const action = toolListData[props.itemIndex].isTranscript ? 4 : 1;
    const action = 1;
    request
        .queryYtDlpVideoInfo(link, videoSource, captchaToken, captchaType, temp, action)
        .then((data) => {
            if (data.response?.status === 429) {
                ElMessage({
                    message: "You\u0027ve exceed the download limit. Please try again later.",
                    type: "error",
                });

                send.collect(send.vmw_searchError);
                saveLinkErrorInfo(link, "You\u0027ve exceed the download limit. Please try again later.", true);
                showLoading.value = false;
                isShowDownloaderHeaderMore.value = false;
                return;
            }
            if (data.code == 0) {
                if (data.data.errCode) {
                    // 根据状态码判断是否错误
                    showLoading.value = false;
                    linkUploadErrorText.value = translateWrongCopyUploadByLink(data.data.errCode);
                    send.collect(send.vmw_searchError);
                    ElMessage({
                        message: linkUploadErrorText.value,
                        type: "error",
                    });
                    reset();
                    // send.collect(send.toolsDownloader_searcherror, {
                    //     fromPage: urlAddress.value,
                    // });
                    let sendErrorCode = data.data.errCode;
                    if (data.data.errCode == constants.UPLOAD_BY_LINK_UPLOAD_FAILED) {
                        sendErrorCode = 213;
                    } else if (data.data.errCode == constants.UPLOAD_BY_LINK_DOWNLOAD_SPEED_SLOW) {
                        sendErrorCode = 214;
                    } else if (data.data.errCode == constants.UPLOAD_BY_LINK_DOWNLOAD_EXCEPTION) {
                        sendErrorCode = 215;
                    } else if (data.data.errCode == constants.UPLOAD_BY_LINK_FAILED_GET_INFORMATION) {
                        sendErrorCode = 216;
                    }
                    // send.collect(send.toolsDownloader_clickDownloadError, { errorCode: sendErrorCode });
                    saveLinkErrorInfo(
                        link,
                        linkUploadErrorText.value,
                        sendErrorCode == constants.UPLOAD_BY_LINK_TOO_MUCH_REQUEST
                    );
                } else if (data.data.duration >= 5 * 60 * 60) {
                    showLoading.value = false;
                    linkUploadErrorText.value = "Video cannot be longer than 5 hr";
                    ElMessage({
                        message: linkUploadErrorText.value,
                        type: "error",
                    });

                    send.collect(send.vmw_searchError);
                    // send.collect(send.toolsDownloader_clickDownloadError, { errorCode: 5 });
                    saveLinkErrorInfo(link, linkUploadErrorText.value);
                } else {
                    // 这里是成功获取到了数据
                    previewVideoThumbnailUrl.value = data.data.thumbnailUrl;
                    previewVideoTitle.value = data.data.videoName;
                    let previewVideoList = data.data.formats;
                    // 为每个视频对象添加 videoRatio 属性
                    previewVideoList.forEach((video) => {
                        video.videoRatio = getResolutionLabel(video.width, video.height);
                        video.ext = video.ext.toUpperCase();
                    });
                    // 对接口返回对formats进行排序，音频+视频排最前面，纯视频排中间，纯音频排到最后
                    let videoWithAudio = [];
                    let videoWithoutAudio = [];
                    let audio = [];
                    previewVideoList.forEach((video) => {
                        if (video.containsVideo && video.containsAudio) {
                            videoWithAudio.push(video);
                        }
                        if (video.containsVideo && !video.containsAudio) {
                            videoWithoutAudio.push(video);
                        }
                        if (!video.containsVideo && video.containsAudio) {
                            audio.push(video);
                        }
                    });
                    videoWithAudio.reverse();
                    videoWithoutAudio.reverse();
                    audio.reverse();
                    previewVideoList = [];
                    for (let i = 0; i < videoWithAudio.length; i++) {
                        previewVideoList.push(videoWithAudio[i]);
                    }
                    for (let i = 0; i < videoWithoutAudio.length; i++) {
                        previewVideoList.push(videoWithoutAudio[i]);
                    }
                    for (let i = 0; i < audio.length; i++) {
                        previewVideoList.push(audio[i]);
                    }
                    lastWithAudioIndex.value = videoWithAudio.length - 1;
                    firstPureAudioIndex.value = videoWithAudio.length + videoWithoutAudio.length;
                    // 原本接口返回的默认下载地址
                    let originalLink = data.data.downloadUrl;
                    let deafultIndex = previewVideoList.findIndex((item) => item.url === originalLink);
                    deafultIndex = deafultIndex === -1 ? 0 : deafultIndex; // 如果没有找到，设置为0
                    options.value = previewVideoList;
                    btnLoadings.value = options.value.map(() => false);
                    selectedOptionIndex.value = deafultIndex;
                    isCached.value = data.data.isCached;
                    youtubeInfo.value = data.data;
                    showLoading.value = false;
                    isDisable.value = false;
                }
            } else {
                // 人机检测失败
                if (data.code == -6000) {
                    isShowDownloaderHeaderMore.value = false;
                    ElMessage({
                        message: "Failed to pass verify, please try again",
                        type: "error",
                    });

                    send.collect(send.vmw_searchError);
                } else if (data.code == -6001) {
                    // 需要主动人机检测
                    targetVideoLink.value = link;
                    targetVideoSource.value = videoSource;
                    showVisible.value = true;
                    showLoading.value = false;
                    isShowDownloaderHeaderMore.value = false;
                } else {
                    ElMessage({
                        message: "Something went wrong, please try again",
                        type: "error",
                    });
                    saveLinkErrorInfo(link, linkUploadErrorText.value);

                    send.collect(send.vmw_searchError);
                }
                showLoading.value = false;
            }
        })
        .catch(() => {
            showLoading.value = false;
            ElMessage({
                message: "Something went wrong, please try again",
                type: "error",
            });

            send.collect(send.vmw_searchError);
        });
}

onMounted(() => {
    getBlock4ContentInfoHeight();
    setBlock4ContentInfoHeight();

    const redirectedInfo = getRedirectedInfo();
    if (redirectedInfo) {
        send.collect(send.vmw_fromCdYoutube);
        let youtubeUrl = "https://www.youtube.com";
        downloadUrl.value = youtubeUrl + redirectedInfo;
        pasteToGetVideoInfo();
        clearRedirectedInfo();
    }
});
</script>

<style lang="scss" scoped>
.web {
    .tool-header-area {
        background: #eff8ff;
        padding: 96px 112px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .tool-title {
            color: #0c111d;
            text-align: center;

            font-family: Inter-Semibold;
            font-size: 60px;
            line-height: 72px;
            margin-bottom: 12px;
        }
        .tool-header-text {
            color: #667085;
            text-align: center;

            font-family: Inter-Regular;
            font-size: 20px;
            width: 758px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
        .download-tool-input {
            display: flex;
            margin: 40px auto 20px;
            align-items: center;
            justify-content: space-between;
            width: 758px;
            box-sizing: border-box;
            padding: 8px;
            border-radius: 16px;
            background: #fff;
            box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.24), 0px 3px 32px 0px rgba(0, 0, 0, 0.12);
            margin-bottom: 20px;
            position: relative;
            .linkIcon {
                font-size: 22px;
                color: #0c111d;
                margin-left: 12px;
                margin-right: 16px;
            }
            .text-input {
                border: 0;
                flex: 1;
                height: 24px;
                margin-right: 37px;
                font-size: 16px;
                color: #98a2b3;

                font-family: Inter-Regular;
                font-size: 16px;
                line-height: 24px;
                &::placeholder {
                    color: $Gray500;
                }
                &:focus {
                    outline: 0;
                    color: #0c111d;
                }
            }
            .link-button {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 48px;
                padding: 12px 20px;
                border: 0;
                border-radius: 12px;
                background: #2e90fa;
                font-family: "Inter-Semibold";
                font-size: 16px;
                line-height: 24px;
                color: rgba(255, 255, 255, 1);
                cursor: pointer;
                .icon-download {
                    font-size: 20px;
                    margin-right: 8px;
                }
                .base-button-loading-icon {
                    color: rgba(255, 255, 255, 1);
                }
                &:hover {
                    background-color: #1570ef;
                }

                &:active {
                    background-color: #2e90fa;
                }
            }
            .link-button[disabled] {
                background-color: #b2ddff;
                cursor: not-allowed;
            }
        }
        .tool-user-guide-tip {
            color: #667085;
            text-align: center;
            width: 758px;

            font-family: Inter-Regular;
            font-size: 16px;
            line-height: 24px;
            .guide-tip-router {
                color: #4fb9fd;
                font-family: "Inter-SemiBold";
                text-decoration: none;
            }
        }
        .tool-video-detail {
            display: flex;
            width: 758px;
            margin-top: 40px;
            box-sizing: border-box;
            padding: 24px;
            flex-direction: column;
            align-items: flex-start;
            gap: 24px;
            border-radius: 16px;
            background: #fff;
            box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.24), 0px 3px 32px 0px rgba(0, 0, 0, 0.12);
            .video-image-info {
                display: flex;
                gap: 12px;
                .video-image {
                    width: 200px;
                    height: 112px;
                    border-radius: 8px;
                    background: lightgray 50% / cover no-repeat;
                }
            }
            .video-download-info {
                width: 100%;
                .video-resource-title {
                    display: flex;
                    padding: 6px 14px;
                    align-items: center;
                    background: #f2f4f7;
                    color: #2d3748;

                    font-family: Inter-Medium;
                    font-size: 14px;
                    line-height: 20px; /* 142.857% */
                }
                .video-resource-content {
                    display: flex;
                    padding: 8px 16px;
                    justify-content: space-between;
                    .video-des {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        .video-icon {
                            color: #2d3748;
                        }
                        iconpark-icon {
                            font-size: 24px;
                        }
                        .video-config-info {
                            color: #2d3748;
                            text-align: center;

                            font-family: Inter-Medium;
                            font-size: 14px;
                            line-height: 20px;
                        }
                        .video-format {
                            display: flex;
                            padding: 2px 6px;
                            justify-content: center;
                            align-items: center;
                            gap: 10px;
                            border-radius: 4px;
                            background: #e4e7ec;
                            color: var(--Gray-950, #0c111d);
                            text-align: center;

                            font-family: Inter-Regular;
                            font-size: 12px;
                            line-height: 18px;
                        }
                    }
                    .video-download-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 36px;
                        padding: 8px 14px;
                        border: 0;
                        border-radius: 10px;
                        background: #d1e9ff;
                        font-family: "Inter-Semibold";
                        font-size: 16px;
                        line-height: 24px;
                        color: #1570ef;
                        width: 123px;

                        font-size: 14px;
                        cursor: pointer;
                        .icon-download {
                            font-size: 20px;
                            margin-right: 8px;
                        }
                        .base-button-loading-icon {
                            color: rgba(255, 255, 255, 1);
                        }
                        &:hover {
                            background-color: #b2ddff;
                        }

                        &:active {
                            background-color: #d1e9ff;
                        }
                    }
                }
            }
        }
        .tool-reset-btn {
            margin-top: 16px;
            color: #2d3748;
            display: flex;
            gap: 8px;
            cursor: pointer;
            justify-content: center;

            font-family: Inter-Semibold;
            font-size: 16px;
            line-height: 24px;
            iconpark-icon {
                font-size: 20px;
            }
        }
    }
    .tool-download-link-wrapper {
        padding: 48px 112px;
        .tool-download-link-top {
            display: flex;
            padding: 40px 72px;
            justify-content: center;
            align-items: center;
            gap: 56px;
            flex: 1 0 0;
            border-radius: 24px;
            max-width: 1440px;
            box-sizing: border-box;
            margin: 0 auto;
            background: #defff2;
            img {
                width: 90px;
            }
            .download-link-text {
                display: flex;
                flex-direction: column;
                color: #0c111d;
                .download-link-title {
                    font-family: Inter-SemiBold;
                    font-size: 30px;
                    line-height: 38px;
                    margin-bottom: 6px;
                }
                .download-link-des {
                    font-family: Inter-Regular;
                    font-size: 18px;
                    line-height: 28px;
                }
            }
            .download-link-btn {
                display: flex;
                flex-shrink: 0;
                align-items: center;
                justify-content: center;
                padding: 16px 28px;
                border: 0;
                border-radius: 12px;
                background: #2d3748;
                font-family: "Inter-Semibold";
                font-size: 16px;
                line-height: 24px;
                color: rgba(255, 255, 255, 1);
                cursor: pointer;
                .icon-download {
                    font-size: 20px;
                    margin-right: 8px;
                }
                .base-button-loading-icon {
                    color: rgba(255, 255, 255, 1);
                }
                &:hover {
                    background-color: #182230;
                }

                &:active {
                    background-color: #2d3748;
                }
            }
        }
    }
    .section-block {
        padding: 80px 112px;
    }
    .tool-function-block {
        max-width: 1440px;
        margin: 0 auto;
        .fun-block-title {
            color: #0c111d;
            text-align: center;

            /* Display md/Semibold */
            font-family: Inter-Semibold;
            font-size: 36px;
            line-height: 44px;
        }
        .fun-block-des {
            color: #667085;
            text-align: center;
            width: 856px;
            margin: 20px auto 64px;

            /* Text xl/Regular */
            font-family: Inter-Regular;
            font-size: 20px;
        }
        .fun-block-content {
            display: flex;
            gap: 56px;
            flex-wrap: wrap;
            .tool-fun-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: calc((100% - 112px) / 3);
                .fun-item-icon {
                    display: flex;
                    padding: 24px;
                    width: 88px;
                    height: 88px;
                    box-sizing: border-box;
                    align-items: center;
                    gap: 10px;
                    border-radius: 16px;
                    background: #d1e9ff;
                    iconpark-icon {
                        font-size: 40px;
                        color: #194185;
                    }
                }
                .fun-item-title {
                    margin-top: 32px;
                    margin-bottom: 8px;
                    color: #0c111d;
                    text-align: center;

                    font-family: Inter-Semibold;
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 30px;
                }
                .fun-item-des {
                    color: var(--Gray-500, #667085);
                    text-align: center;

                    /* Text md/Regular */
                    font-family: Inter-Regular;
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        }
    }
    .tool-use-block {
        margin: 0 auto;
        max-width: 1440px;
        .use-block-title {
            color: #0c111d;
            text-align: center;
            font-family: Inter-Semibold;
            font-size: 36px;
            line-height: 44px;
            margin-bottom: 64px;
        }
        .use-block-content {
            display: flex;
            justify-content: space-around;
        }
        .use-block-item {
            width: 368px;
            img {
                width: 100%;
                height: auto;
            }
            .use-title {
                color: #0c111d;
                text-align: center;
                margin-top: 32px;
                margin-bottom: 8px;
                font-family: Inter-Semibold;
                font-size: 20px;
                line-height: 30px;
            }
            .use-des {
                color: #667085;
                text-align: center;

                font-family: Inter-Regular;
                font-size: 16px;
                line-height: 24px;
            }
        }
    }
    .domain-block {
        max-width: 1440px;
        margin: 0 auto;
        h2 {
            color: #0c111d;
            text-align: center;
            font-family: Inter-Semibold;
            font-size: 36px;
            line-height: 44px;
        }
        img {
            width: 712px;
            display: block;
            margin: 64px auto;
        }
        .domain-content {
            display: flex;
            justify-content: center;
            gap: 56px;
            .domain-item {
                width: calc((100% - 112px) / 3);
                max-width: 368px;
                display: flex;
                gap: 8px;
                flex-direction: column;
                .domain-title {
                    color: #0c111d;
                    text-align: center;

                    font-family: Inter-Semibold;
                    font-size: 20px;
                    line-height: 30px;
                }
                .domain-des {
                    color: #667085;
                    text-align: center;

                    font-family: Inter-Regular;
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        }
    }
    .tool-faq-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 80px 112px;

        .faqHeader {
            text-align: center;
            margin-bottom: 64px;

            .faqTitle {
                color: #0c111d;
                text-align: center;
                margin-bottom: 20px;

                font-family: Inter-SemiBold;
                font-size: 36px;
                line-height: 44px;
            }

            .faqDescribe {
                color: #667085;
                text-align: center;
                font-family: Inter-Regular;
                font-size: 20px;
                font-weight: 400;
            }
        }

        .faqContent {
            width: 768px;

            .faqContentTitle {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-family: "Inter-Regular" !important;
                font-size: 18px;
                line-height: 28px;
                color: #667085;
                padding-top: 24px;
                border-top: 1px solid $Gray100;
                margin-top: 32px;
                user-select: none;
                padding-bottom: 8px;
                cursor: pointer;
                h3 {
                    color: #0c111d;

                    /* Text lg/Medium */
                    font-family: Inter-Medium;
                    font-size: 18px;
                    line-height: 28px;
                }
                iconpark-icon {
                    font-size: 24px;
                    color: #98a2b3;
                }
            }

            .faqContentTitle:first-child {
                padding-top: 0;
                border-top: 0;
                margin-top: 0;
            }

            .faqContentInfo {
                color: #667085;

                overflow: hidden;
                white-space: pre-wrap;
                transition: all 0.2s linear;

                font-family: "Inter-Regular";
                font-size: 16px;
                line-height: 24px;
            }
        }
    }
    .tool-download-link-bottom {
        padding: 0 112px 80px 112px;
        .tool-download-link-inner {
            max-width: 1440px;
            margin: 0 auto;
            box-sizing: border-box;
            display: flex;
            padding: 40px 72px;
            align-items: center;
            gap: 56px;
            border-radius: 24px;
            background: #defff2;
            color: var(--Gray-950, #0c111d);
            .download-left-content {
                flex-basis: 560px;
                .download-title {
                    font-family: Inter-Semibold;
                    font-size: 30px;
                    line-height: 38px;
                    margin-bottom: 16px;
                }
                .download-des {
                    font-family: Inter-Regular;
                    font-size: 18px;
                    line-height: 28px;
                }
            }
            .download-right-content {
                width: 456px;
                img {
                    width: 100%;
                }
                .download-link-btn {
                    display: flex;
                    flex-shrink: 0;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    padding: 16px 28px;
                    border: 0;
                    border-radius: 12px;
                    background: #2d3748;
                    font-family: "Inter-Semibold";
                    font-size: 16px;
                    line-height: 24px;
                    color: rgba(255, 255, 255, 1);
                    cursor: pointer;
                    .icon-download {
                        font-size: 20px;
                        margin-right: 8px;
                    }
                    .base-button-loading-icon {
                        color: rgba(255, 255, 255, 1);
                    }
                    &:hover {
                        background-color: #182230;
                    }

                    &:active {
                        background-color: #2d3748;
                    }
                }
            }
        }
    }
}

.mobile {
    .tool-header-area {
        background: #eff8ff;
        padding: 0.64rem 0.16rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .tool-title {
            color: #0c111d;
            text-align: center;

            font-family: Inter-Semibold;
            font-size: 0.48rem;
            line-height: 0.6rem;
            margin-bottom: 0.1rem;
            letter-spacing: -0.0096rem;
        }
        .tool-header-text {
            color: #667085;
            text-align: center;

            font-family: Inter-Regular;
            font-size: 0.18rem;
        }
        .download-tool-input {
            width: 100%;
            margin-top: 0.4rem;
            margin-bottom: 0.2rem;
            .input {
                display: flex;
                align-items: center;
                height: 0.56rem;
                box-shadow: 0rem 0.03rem 0.12rem 0rem rgba(0, 0, 0, 0.08), 0rem 0rem 0.02rem 0rem rgba(0, 0, 0, 0.16);
                background-color: #fff;
                padding: 0.08rem;
                box-sizing: border-box;
                border-radius: 0.12rem;
                margin-bottom: 0.2rem;
                position: relative;
                .linkIcon {
                    font-size: 0.22rem;
                    color: #0c111d;
                    margin-left: 0.06rem;
                    margin-right: 0.08rem;
                }
                .text-input {
                    border: 0;
                    flex: 1;
                    height: 0.2rem;
                    font-family: "Inter-Regular" !important;
                    font-size: 0.14rem;
                    line-height: 0.2rem;
                    color: #63637e;
                    &::placeholder {
                        color: $Gray500;
                    }
                    &:focus {
                        outline: 0;
                    }
                }
            }
            .link-button {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 0.48rem;
                width: 100%;
                padding: 0.12rem 0.2rem;
                border: 0;
                border-radius: 0.12rem;
                background: #2e90fa;
                font-family: "Inter-Semibold";
                font-size: 0.16rem;
                line-height: 0.24rem;
                color: rgba(255, 255, 255, 1);
                cursor: pointer;
                .icon-download {
                    font-size: 0.2rem;
                    margin-right: 0.08rem;
                }
                .base-button-loading-icon {
                    color: rgba(255, 255, 255, 1);
                }
                &:hover {
                    background-color: #1570ef;
                }

                &:active {
                    background-color: #2e90fa;
                }
            }
        }
        .link-focus {
            box-shadow: 0px 0px 0px 4px #f4ebff, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
        }
        .tool-user-guide-tip {
            color: #667085;
            text-align: center;

            font-family: Inter-Regular;
            font-size: 0.14rem;
            line-height: 0.2rem;
            .guide-tip-router {
                color: #4fb9fd;
                font-family: "Inter-SemiBold";
                text-decoration: none;
            }
        }
        .tool-video-detail {
            display: flex;
            box-sizing: border-box;
            padding: 0.16rem;
            margin-top: 0.4rem;
            flex-direction: column;
            gap: 0.24rem;
            border-radius: 0.16rem;
            background: #fff;
            box-shadow: 0 0 0.01rem 0 rgba(0, 0, 0, 0.24), 0 0.03rem 0.32rem 0 rgba(0, 0, 0, 0.12);
            .video-image-info {
                display: flex;
                flex-direction: column;
                gap: 0.12rem;
                .video-image {
                    width: 3.11rem;
                    height: 1.75rem;
                    border-radius: 0.08rem;
                    background: lightgray 50% / cover no-repeat;
                }
                .video-info-title {
                    color: #0c111d;

                    font-family: Inter-Medium;
                    font-size: 14px;
                    line-height: 20px;
                }
            }
            .video-download-info {
                margin-top: 0.24rem;
                width: 100%;
                .video-resource-title {
                    display: flex;
                    padding: 0.06rem 0.08rem;
                    align-items: center;
                    background: #f2f4f7;
                    color: #2d3748;

                    font-family: Inter-Medium;
                    font-size: 0.14rem;
                    line-height: 0.2rem; /* 142.857% */
                }
                .video-resource-content {
                    display: flex;
                    gap: 0.13rem;
                    padding: 0.08rem 0rem;
                    flex-direction: column;
                    justify-content: space-between;
                    .video-des {
                        display: flex;
                        align-items: center;
                        gap: 0.06rem;
                        iconpark-icon {
                            font-size: 0.24rem;
                        }
                        .video-config-info {
                            color: #2d3748;
                            text-align: center;

                            font-family: Inter-Medium;
                            font-size: 0.14rem;
                            line-height: 0.2rem;
                        }
                        .video-format {
                            display: flex;
                            padding: 0.02rem 0.06rem;
                            justify-content: center;
                            align-items: center;
                            gap: 0.1rem;
                            border-radius: 0.04rem;
                            background: #e4e7ec;
                            color: var(--Gray-950, #0c111d);
                            text-align: center;

                            font-family: Inter-Regular;
                            font-size: 0.12rem;
                            line-height: 0.18rem;
                        }
                    }
                    .video-download-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 0.36rem;
                        padding: 0.08rem 0.14rem;
                        border: 0;
                        border-radius: 0.1rem;
                        background: #d1e9ff;
                        font-family: "Inter-Semibold";
                        font-size: 0.16rem;
                        line-height: 0.24rem;
                        color: #1570ef;

                        font-size: 0.14rem;
                        cursor: pointer;
                        .icon-download {
                            font-size: 0.2rem;
                            margin-right: 0.08rem;
                        }
                        .base-button-loading-icon {
                            color: rgba(255, 255, 255, 1);
                        }
                        &:hover {
                            background-color: #b2ddff;
                        }

                        &:active {
                            background-color: #d1e9ff;
                        }
                    }
                }
            }
        }
        .tool-reset-btn {
            margin-top: 0.16rem;
            color: #2d3748;
            display: flex;
            gap: 0.08rem;
            cursor: pointer;
            justify-content: center;

            font-family: Inter-Semibold;
            font-size: 0.16rem;
            line-height: 0.24rem;
            iconpark-icon {
                font-size: 0.2rem;
            }
        }
    }
    .section-block {
        padding: 0.64rem 0.16rem;
    }
    .tool-function-block {
        .fun-block-title {
            color: #0c111d;
            text-align: center;

            /* Display md/Semibold */
            font-family: Inter-Semibold;
            font-size: 0.3rem;
            line-height: 0.38rem;
        }
        .fun-block-des {
            color: #667085;
            text-align: center;
            margin: 0.2rem auto 0.48rem;

            font-family: Inter-Regular;
            font-size: 0.18rem;
            line-height: 0.28rem;
        }
        .fun-block-content {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;
            flex-wrap: wrap;
            .tool-fun-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
                .fun-item-icon {
                    display: flex;
                    padding: 0.17rem;
                    width: 0.64rem;
                    height: 0.64rem;
                    box-sizing: border-box;
                    align-items: center;
                    border-radius: 0.11rem;
                    background: #d1e9ff;
                    iconpark-icon {
                        font-size: 0.3rem;
                        color: #194185;
                    }
                }
                .fun-item-title {
                    margin-top: 0.16rem;
                    margin-bottom: 0.08rem;
                    color: #0c111d;
                    text-align: center;

                    font-family: Inter-Semibold;
                    font-size: 0.18rem;
                    line-height: 0.28rem;
                }
                .fun-item-des {
                    color: var(--Gray-500, #667085);
                    text-align: center;

                    /* Text md/Regular */
                    font-family: Inter-Regular;
                    font-size: 0.14rem;
                    line-height: 0.2rem;
                }
            }
        }
    }
    .tool-use-block {
        .use-block-title {
            color: #0c111d;
            text-align: center;
            font-family: Inter-Semibold;
            font-size: 0.3rem;
            margin-bottom: 0.48rem;
        }
        .use-block-content {
            display: flex;
            flex-direction: column;
            gap: 0.48rem;
        }
        .use-block-item {
            width: 100%;
            img {
                width: 3.43rem;
            }
            .use-title {
                color: #0c111d;
                text-align: center;
                margin-top: 0.16rem;
                margin-bottom: 0.08rem;
                font-family: Inter-Semibold;
                font-size: 0.18rem;
                line-height: 0.28rem;
            }
            .use-des {
                color: #667085;
                text-align: center;

                font-family: Inter-Regular;
                font-size: 0.14rem;
                line-height: 0.2rem;
            }
        }
    }
    .tool-faq-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 0.64rem 0.16rem;
        box-sizing: border-box;

        .faqHeader {
            text-align: center;
            margin-bottom: 0.48rem;

            .faqTitle {
                color: #0c111d;
                text-align: center;
                margin-bottom: 0.2rem;

                font-family: Inter-SemiBold;
                font-size: 0.3rem;
                line-height: 0.38rem;
            }

            .faqDescribe {
                color: #667085;
                text-align: center;
                font-family: Inter-Regular;
                font-size: 0.18rem;
                line-height: 0.28rem;
            }
        }

        .faqContent {
            padding: 0 16px;
            .faqContentTitle {
                position: relative;
                display: flex;
                gap: 0.08rem;
                align-items: start;
                justify-content: space-between;
                font-family: "Inter-Regular" !important;
                font-size: 0.14rem;
                line-height: 0.24rem;
                color: #667085;
                padding-top: 0.24rem;
                border-top: 0.01rem solid $Gray100;
                margin-top: 0.32rem;
                user-select: none;
                padding-bottom: 0.08rem;
                cursor: pointer;
                h3 {
                    color: #0c111d;

                    /* Text lg/Medium */
                    font-family: Inter-Medium;
                    font-size: 0.16rem;
                    line-height: 0.28rem;
                }
                iconpark-icon {
                    font-size: 0.24rem;
                    color: #98a2b3;
                }
            }

            .faqContentTitle:first-child {
                padding-top: 0;
                border-top: 0;
                margin-top: 0;
            }

            .faqContentInfo {
                color: #667085;

                overflow: hidden;
                white-space: pre-wrap;
                transition: all 0.2s linear;

                font-family: "Inter-Regular";
                font-size: 0.16rem;
                line-height: 0.24rem;
            }
        }
    }
}
</style>
